// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3MMsA","ranges":"BmiRanges_ranges__3pl9o"};